import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowDivider: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.surface.secondary,
      '&:after, &:before': {
        borderColor: 'inherit',
      },
    }),
  },
};
